import { AxiosError, isAxiosError } from 'axios'
import { AsyncResult, Err, Ok } from 'ts-results-es'

/**
 * Wraps an Axios promise to return an AsyncResult instead of throwing errors.
 * This allows for more predictable error handling by converting Axios errors
 * into Result types that can be handled explicitly.
 *
 * @param promise - The Axios promise to wrap
 * @returns Success or AxiosError wrapped in AsyncResult
 */
export function wrapAxiosPromise<T>(promise: Promise<T>): AsyncResult<T, AxiosError> {
    const resultPromise = promise.then(
        (value) => Ok(value),
        (e) => {
            // Use isAxiosError instead of instanceof AxiosError as recommended.
            if (isAxiosError(e)) {
                return Err(e)
            }
            throw e
        },
    )
    return new AsyncResult(resultPromise)
}
